// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearAllCacheExceptTheme } from '../../lib/localStorageHandler';
import { signOut } from './authSlice';

const Signout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleSignout = async () => {
      try {
        // Dispatch signOut action first
        dispatch(signOut());

        // Clear all cache data except theme preferences
        await clearAllCacheExceptTheme();

        // Navigate to signin page
        navigate('/signin', { replace: true });

        // Reload the page to ensure clean state
        window.location.reload();
      } catch (error) {
        console.error('Error during signout:', error);
        // Even if cache clearing fails, continue with signout process
        navigate('/signin', { replace: true });
        window.location.reload();
      }
    };

    handleSignout();
  }, [dispatch, navigate]);

  return null;
};

export default Signout;
